import { useCallback, useState } from 'react';
import logger from '../../../utils/logger';

export function useCommentDeleteDialog({ onDelete, onDeleteReply }) {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [selectedCommentId, setSelectedCommentId] = useState(null);
  const [selectedReplyIndex, setSelectedReplyIndex] = useState(null);
  const [selectedCommentIndex, setSelectedCommentIndex] = useState(null);

  const handleOpenConfirmDialog = useCallback(
    (commentId, replyIndex = null, commentIndex = null) => {
      setSelectedCommentId(commentId ?? null);
      setSelectedReplyIndex(replyIndex ?? null);
      setSelectedCommentIndex(commentIndex ?? null);
      setShowConfirmDialog(true);
    },
    []
  );

  const handleCloseDialog = useCallback(() => {
    setShowConfirmDialog(false);
    setSelectedCommentId(null);
    setSelectedReplyIndex(null);
    setSelectedCommentIndex(null);
  }, []);

  const handleConfirmDelete = useCallback(() => {
    if (selectedCommentId !== null || selectedCommentIndex !== null) {
      if (selectedReplyIndex !== null) {
        if (typeof onDeleteReply === 'function') {
          onDeleteReply(
            selectedCommentId,
            selectedReplyIndex,
            selectedCommentIndex
          );
        } else {
          logger.warn(
            'onDeleteReply is not defined, falling back to onDelete'
          );
          onDelete(selectedCommentId, selectedCommentIndex);
        }
      } else {
        onDelete(selectedCommentId, selectedCommentIndex);
      }
    }
    handleCloseDialog();
  }, [
    onDelete,
    onDeleteReply,
    selectedCommentId,
    selectedCommentIndex,
    selectedReplyIndex,
    handleCloseDialog,
  ]);

  return {
    showConfirmDialog,
    selectedReplyIndex,
    handleOpenConfirmDialog,
    handleCloseDialog,
    handleConfirmDelete,
  };
}
